import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, VStack, HStack, Text, Button, Icon } from '@chakra-ui/react';
import { WarningIcon } from '@chakra-ui/icons';

const SubscriptionFailure = () => {
  const navigate = useNavigate();

  const onTryAgain = () => {
    navigate('/pricing');
  };

  const onContactSupport = () => {};

  return (
    <Box
      bg="red.50"
      w="100%"
      maxW="400px"
      mx="auto"
      mt="20"
      mb="8"
      p="6"
      boxShadow="lg"
      borderRadius="md"
    >
      <VStack spacing={4}>
        {/* Failure Icon */}
        <Icon as={WarningIcon} boxSize={12} color="red.500" />

        {/* Failure Message */}
        <Text fontSize="xl" fontWeight="bold" color="red.600">
          Subscription Failed
        </Text>
        <Text fontSize="md" color="gray.600">
          Unfortunately, we were unable to process your subscription. Please try
          again or contact support for assistance.
        </Text>

        {/* Buttons in Parallel */}
        <HStack spacing={4} w="full" justify="center">
          <Button colorScheme="red" variant="solid" onClick={onTryAgain}>
            Try Again
          </Button>
          <Button
            colorScheme="gray"
            variant="outline"
            onClick={onContactSupport}
          >
            Contact Support
          </Button>
        </HStack>
      </VStack>
    </Box>
  );
};

export default SubscriptionFailure;
